import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { IncomePaymentOneOffDispatcher } from "./Variable";


export interface IncomePaymentOneOffState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class IncomePaymentOneOffStatic extends BaseStore<IncomePaymentOneOffState> {
    constructor() {
        super();
        this.subscribeToDispatcher(IncomePaymentOneOffDispatcher, (actionData) => this.onIncomePaymentOneOffStoreResponse(actionData));
    }

    public getLastResult(): IncomePaymentOneOffState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }
   
    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): IncomePaymentOneOffState {
        return { actionType: ActionType.Loading, data: null, };
    }

    private onIncomePaymentOneOffStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                    this.setState({ actionType: actionData.actionType });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
